export default __webpack_public_path__ + "static/media/cleanproWelcomeV2.23afd8a3.png";